import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class TranslateService {
    constructor(http) {
        this.http = http;
        this.data = {};
    }
    use(lang) {
        return new Promise((resolve, reject) => {
            const langPath = "../../assets/i18n/${lang || 'en'}.json";
            this.http.get(langPath).subscribe(translation => {
                this.data = Object.assign({}, translation || {});
                resolve(this.data);
            }, error => {
                this.data = {};
                resolve(this.data);
            });
        });
    }
}
TranslateService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TranslateService_Factory() { return new TranslateService(i0.ɵɵinject(i1.HttpClient)); }, token: TranslateService, providedIn: "root" });
